/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;
const ACTIVE_TAB_CLASS = "search-results__tab-label--active";

export default function init() {
    window.addEventListener("load", function () {
        let searchResultsForm = this.document.querySelector("#search-results-form");

        if (searchResultsForm) {

          searchResultsForm.addEventListener("submit", function (event) {
            event.preventDefault();
            let queryInput = this.querySelector("#query");
            if (queryInput) {
                updateSearchResultsQuery(queryInput.value);
            }
        });

            window.onpopstate = function (e: any) {
                if (e.state) {
                    $("#results-append").html(e.state.content).hide().fadeIn();

                    document.title = e.state.pageTitle;

                    $("#query").val(e.state.query);
                        $("#searchtype").val(e.state.searchtype);

                        let documentsPage = this.document.querySelector("#productrangefilter");
                        if (documentsPage) {
                                $("#productrangefilter").val(e.state.productRange);
                                $("#documenttypefilter").val(e.state.documentType);
                                $("#documentlanguagefilter").val(e.state.documentLanguage);
                        }
                    

                    $(".js-search-tab").removeClass(ACTIVE_TAB_CLASS);
                    $(
                        ".js-search-tab[data-searchtype=" + e.state.searchtype + "]"
                    ).addClass(ACTIVE_TAB_CLASS);

                    $(".js-page-link")
                        .off("click")
                        .click(function () {
                            search($(this).data("pagenumber"), false, false);
                        });
                }
            };

            $(".js-search-tab").click(function () {
                let newSearchType = $(this).data("searchtype");
                $("#searchtype").val(newSearchType);

                if (newSearchType === "documents") {
                    $("#documents-filters-wrapper").removeClass("d-none");
                } else {
                    $("#documents-filters-wrapper").addClass("d-none");
                }

                $(".js-search-tab").removeClass(ACTIVE_TAB_CLASS);
                $(this).addClass(ACTIVE_TAB_CLASS);

                search(1, false, false);
            });

            $(searchResultsForm)
                .off("submit")
                .submit(function (e) {
                    e.preventDefault();

                    search(1, false, true);
                });
            search($("#requestedPage").val(), true, false);            
        }
    });

    function updateSearchResultsQuery(query: string) {
      let resultsQueryContainer = document.querySelector(".container.search-results-query p");
      if (resultsQueryContainer) {
          resultsQueryContainer.textContent = `Results for '${query}'`;
      }
  }

    function search(page: any, replaceState: boolean, countResults: boolean) {
        let productrangeField = $("#productrangefilter").val();
        let documenttypeField = $("#documenttypefilter").val();
        let documentlanguageField = $("#documentlanguagefilter").val();

        let searchtype = $("#searchtype").val().toString();
        let query = $("#query").val().toString();
        let pagecontentguid = $("#pageContentGuid").val();
        let pagelanguage = $("#pageLanguage").val();
        let productrange = productrangeField != undefined ? productrangeField : "";
        let documenttype = documenttypeField != undefined ? documenttypeField : "";
        let documentlanguage = documentlanguageField != undefined ? documentlanguageField : "";
        let searchResultsContainer = $(".js-search-results-container");

        $("#search-container").attr("aria-live", "polite");
        $("#search-container").attr("aria-busy", "true");

        $("#search-results-loader").removeClass("d-none");

        $("#results-append").fadeOut();

        // Used for just render the last ajax call
        let seqNumber = ++xhrNumber;

        $.get("/searchresultspage/search/", {
            query,
            searchtype,
            pagecontentguid,
            pagelanguage,
            productrange,
            documenttype,
            documentlanguage,
            page,
            countResults: countResults
        })
            .done(function (data) {
                if (xhrNumber === seqNumber) {
                    $("#results-append").html(data).hide().fadeIn();

                    $(".js-page-link")
                        .off("click")
                        .click(function () {
                            search($(this).data("pagenumber"), false, false);
                        });

                    if (countResults) {
                        let productsQuantity = $("#productsQuantity").val();
                        let contentsQuantity = $("#contentsQuantity").val();
                        let documentsQuantity = $("#documentsQuantity").val();

                        $("#productQuantity").text("" + productsQuantity + "");
                        $("#contentQuantity").text("" + contentsQuantity + "");
                        $("#documentQuantity").text("" + documentsQuantity + "");

                        if (searchtype == "products" && productsQuantity <= 0) {
                            if (contentsQuantity > 0) {
                                $("#contentTabLink").click();
                            }
                            else if (documentsQuantity > 0) {
                                $("#documentTabLink").click();
                            }
                        }

                        if (searchtype == "contents" && contentsQuantity <= 0) {
                            if (documentsQuantity > 0) {
                                $("#documentTabLink").click();
                            }
                            else if (productsQuantity > 0) {
                                $("#productTabLink").click();
                            }
                        }

                        if (searchtype == "documents" && documentsQuantity <= 0) {
                            if (productsQuantity > 0) {
                                $("#productTabLink").click();
                            }
                            else if (contentsQuantity > 0) {
                                $("#contentTabLink").click();
                            }
                        }
                    }

                    let currentPage = $("#currentPage").val();
                    let title = document.title + " - " + currentPage;

                    if (!replaceState) {
                        history.pushState(
                                { content: data, query, searchtype, productrange, documenttype, documentlanguage, pageTitle: title },
                            title,
                            "?query=" +
                                encodeURI(query) +
                                "&searchtype=" +
                                searchtype +
                                "&productrange=" +
                                productrange +
                                "&documenttype=" +
                                documenttype +
                                "&documentlanguage=" +
                                documentlanguage +
                                "&page=" +
                                currentPage
                        );
                    } else {
                        history.replaceState(
                                { content: data, query, searchtype, productrange, documenttype, documentlanguage, pageTitle: title },
                            title,
                            "?query=" +
                                encodeURI(query) +
                                "&searchtype=" +
                                searchtype +
                                "&productrange=" +
                                productrange +
                                "&documenttype=" +
                                documenttype +
                                "&documentlanguage=" +
                                documentlanguage +
                                "&page=" +
                                currentPage
                        );
                    }

                    $("#productrangefilter, #documenttypefilter, #documentlanguagefilter").off("change").change(function () {
                        search(1, false, false);
                    });
                }
            })
            .fail(function (error) {
                if (xhrNumber === seqNumber) {
                    Swal.fire("Oops...", error.statusText, "error");
                    $("#results-append").fadeIn();
                }
            })
            .always(function () {
                if (xhrNumber === seqNumber) {
                    $("#search-results-loader").addClass("d-none");
                    $("#search-container").attr("aria-busy", "false");
                }

                if (xhrNumber > 1) {
                    $("html, body").animate(
                        {
                            scrollTop: searchResultsContainer.offset().top,
                        },
                        500
                    );
                    const resultsMessage = $('#hiddenResultsMessage').val() as string;
                    $('.search-results__results-count').text(resultsMessage);
                }
            });
    }
}
init();